<template>
<div>
    <template v-if="true">
    <div class="white-background mail-item clickable hoverable" v-for="item in items" :key="item._id"  @click="toggleExpansion(item)">
        <div style="display:flex;width:100%;">
            <div style="flex-grow:1" class="truncate"><strong>{{item.email.subject}}</strong></div>
            <div style="flex-basis:100px;margin-left:10px;text-align:right;font-size:14px">{{item.createdAt | fromNow}}</div>
        </div>
        <div style="display:flex;width:100%;">
            <div v-for="recipient in item.email.to" class="email-address truncate" :key="recipient.to" :title="recipient.email">
                {{recipient.email}} 
            </div>           
        </div>    
        <div class="email-heading" v-if="showTo">
            

    
            
        </div>
         <span style="font-weight:300">{{textBody(item.email.body, item.expanded)}}</span>
    </div>
    </template>
</div>
</template>

<script>
import Template from '../builder/Template.vue'
import DataHelpers from '../helpers/DataHelpers'
import StringHelpers from '../helpers/StringHelpers'

export default {
    data() {
        return {
        
        }
    },

    components: {
        Template
        
    },
    
    props: {
        items: Array,
        showTo: Boolean,
    },

    computed: {

    },

    methods: {
        textBody(html, expanded) {
            let str = StringHelpers.removeHtml(html)
            if(!expanded)
                str = StringHelpers.truncateDots(str , 85)
            return str
        },

        toggleExpansion(item) {
            this.$set(item, 'expanded', !item.expanded)
        }
        
    },

    created() {

    }
}
</script>

<style scoped>
    .mail-item {
        border: solid 1px #bbb;
        padding: 5px 10px;
        border-radius:5px;
        margin:5px 0;
        max-height:200px;
        overflow-y:auto;
    }
    .email-heading {
        font-size: 0.7rem;
        font-weight: bold;
    }
    .email-address {
        border:solid 1px #ddd;
        background-color: rgba(0,0,0,0.02);
        border-radius: 4px;
        padding: 1px 4px;
        display: inline-block;
        margin:1px;
        font-size:11px;
    }
</style>




// WEBPACK FOOTER //
// TransactionMail.vue?e6f81498